import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "12", y1: "20", y2: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "18", x2: "18", y1: "20", y2: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "6", x2: "6", y1: "20", y2: "16", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BarChart";
const BarChart = memo(themed(Icon));
export {
  BarChart
};
//# sourceMappingURL=bar-chart.js.map
